import {
  BAD_PASSWORD,
  BAD_TEAM,
  EXISTING_USER,
  GENERIC_ERROR,
  MODAL_STATUS,
  MODAL_TYPE,
  SEND_LINK,
  SEND_LINK_ERROR,
  SEND_LINK_SUCCESS,
  SUBMIT,
  SUBMIT_ERROR,
  SUBMIT_SUCCESS,
} from "./actions";

const signupInit = window.Chuffed.signupInit || {};

const initialState = {
  ...signupInit,
  errorFor: "",
  errorMessage: "",
  isError: false,
  isModalOpen: false,
  isSendingLink: false,
  isSubmitting: false,
  modalType: "",
  sendLinkSuccess: false,
  setPasswordSuccess: false,
  submitSuccess: false,
};

function processErrorsFromAction(action) {
  const errors = [];
  Object.keys(action.responseData.errors).reduce((previous, key) => {
    errors.push(action.responseData.errors[key][0]);
    return action.responseData.errors[key];
  }, 0);
  return errors;
}

// Reducers ----------------------
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SUBMIT:
      return {
        ...state,
        errorFor: "",
        errorMessage: "",
        isError: false,
        isSubmitting: true,
      };
    case SUBMIT_SUCCESS:
      return {
        ...state,
        errorFor: "",
        errorMessage: "",
        fundraiser: action.data.fundraiser,
        isError: false,
        isSubmitting: false,
        submitSuccess: true,
      };
    case SUBMIT_ERROR:
      return {
        ...state,
        errorFor: "submit",
        errorMessage: action.error.error.message,
        isError: true,
        isSubmitting: false,
        submitSuccess: false,
      };
    case SEND_LINK:
      return {
        ...state,
        errorFor: "",
        errorMessage: "",
        isError: false,
        isSendingLink: true,
        sendLinkSuccess: false,
      };
    case SEND_LINK_SUCCESS:
      return {
        ...state,
        isSendingLink: false,
        isModalOpen: false,
        modalType: "",
        sendLinkSuccess: true,
      };
    case SEND_LINK_ERROR:
      return {
        ...state,
        errorFor: "send-link",
        errorMessage: action.error.error,
        isError: true,
        isSendingLink: false,
        sendLinkSuccess: false,
      };
    case MODAL_STATUS:
      return {
        ...state,
        isModalOpen: action.data,
      };
    case MODAL_TYPE:
      return {
        ...state,
        modalType: action.data,
      };
    case EXISTING_USER:
      return {
        ...state,
        isModalOpen: true,
        isSubmitting: false,
        modalType: "existing-user",
      };
    case BAD_PASSWORD:
      return {
        ...state,
        isModalOpen: true,
        isSubmitting: false,
        modalType: "existing-user-bad-pw",
      };
    case BAD_TEAM:
      return {
        ...state,
        isModalOpen: true,
        isSubmitting: false,
        modalType: "team-not-found",
      };
    case GENERIC_ERROR:
      return {
        ...state,
        errorFor: "submit",
        errorMessage: processErrorsFromAction(action).join("<br />"),
        isModalOpen: true,
        isSubmitting: false,
        modalType: "generic-error",
      };
    default:
      return state;
  }
}
